import ProcessTerminated from "common/components/process-terminated";
import { useAppDispatch } from "core/store/hooks";
import { useEffect } from "react";
import { reopenEndStep } from "../_redux/actions";

const ReopenProcessoTerminato: React.FC = () => {
	const dispatch = useAppDispatch();

	const handleClick = () => {
		window.location.href = "https://buffettifinance.com/";
	};

	useEffect(() => {
		dispatch(reopenEndStep(true));
	}, []);

	return (
		<div>
			<ProcessTerminated
				title="Il processo è andato a buon fine!"
				text={
					<div>
						<p style={{ textAlign: "justify" }}>
							Stiamo effettuando le verifiche e riceverai presto via e-mail la comunicazione
							sull'esito della pratica.
						</p>
					</div>
				}
				button="Torna alla home"
				onClick={handleClick}
			/>
		</div>
	);
};

export default ReopenProcessoTerminato;
